import { Modal } from "antd";

/**
 * 通用确认弹窗
 * @param {string} content - 提示文案
 * @param {string} okText  - 确认按钮文字
 * @param {Function} onOk - 确认回调
 */
export function showConfirm(content, okText, onOk) {
  Modal.confirm({
    title: "温馨提示",
    content,
    okText,
    cancelText: "取消",
    centered: true,
    okButtonProps: {
      style: { backgroundColor: "#5B69FC", borderColor: "#5B69FC" },
    },
    onOk,
  });
}
